
Vue.component('modal', modal);
Vue.component('modalU', modalU);
Vue.config.productionTip = false;
Vue.prototype.$URL = 'https://election-calc.online/ajax/API_final.php?client=MM';
Vue.prototype.$URL_login = 'https://election-calc.online/ajax/login.php?client=MM';
Vue.prototype.$URL_isLogged = 'https://election-calc.online/ajax/isLogged.php?client=MM';
Vue.prototype.$URL_dvk = 'https://election-calc.online/MM/dvk/login.php';
Vue.prototype.$http = axios;
//Vue.use(BootstrapVue);
//Vue.use(IconsPlugin);
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'animate.css';

//import 'bootstrap-vue/dist/bootstrap-vue.css'
//import 'bootstrap';
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import modal from './modal.vue'
import modalU from './modalUniversal.vue'
import VueTippy from "vue-tippy";

Vue.use(VueTippy);




Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
